import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../CSS/OurHistory.css';

const OurHistory: React.FC = () => {
  const navigate = useNavigate();
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/About Us Page/about-us-image.png`;
  
  return (
    <div className="our-history-page">
      <div className="our-history-hero">
        <div 
          className="hero-background"
          style={{ 
            backgroundImage: `url("${imagePath}")` 
          }}
        ></div>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <p className="hero-subtitle">About Us / Our History</p>
          <h1 className="hero-title">Empowering Higher Education Through Exceptional Leadership.</h1>
        </div>
      </div>

      <div className="our-history-body">
        <div className="our-history-intro">
          <p>
            For over four decades, <strong>Myers McRae</strong> has been the trusted partner in connecting America's top colleges and universities with the visionary leaders who drive their success. We believe the future of an institution depends entirely on its leadership—and we are dedicated to helping you find the perfect fit.
          </p>
        </div>
        <div className="our-history-expertise">
          <h2 className="expertise-title">Our History & Expertise</h2>
          <div className="expertise-content">
            <p>
              Founded in 1969, Myers McRae initially served multiple sectors before strategically focusing exclusively on <strong>higher education</strong> in 1984. For over four decades, we've dedicated ourselves to placing transformative leaders in universities, colleges, and higher education systems nationwide.
            </p>
            <p>
              Our principals and consultants bring <strong>extensive executive-level experience</strong> in both academic administration and consulting. This deep, firsthand knowledge allows us to understand your institution's unique challenges and opportunities, earning Myers McRae a national reputation for consistently identifying and recruiting the most talented leaders in the field.
            </p>
          </div>
        </div>
        <div className="our-history-advantages">
          <h2 className="advantages-title">The Myers McRae Advantage: Our Core Values</h2>
          <div className="advantages-content">
            <p>
              Our commitment is to deliver service, expertise, and results that exceed expectations. Our approach is guided by these five core values, ensuring a confident and successful partnership:
            </p>
            <ul className="advantages-list">
              <li>
                <strong>Knowledge</strong> - We start with a <strong>deep understanding</strong> of your institution's culture and needs to design a truly tailored search strategy, not a generic template.
              </li>
              <li>
                <strong>Process</strong> - A clear, efficient, and <strong>transparent framework</strong> ensures confidence and predictability, minimizing disruption and saving your team valuable time.
              </li>
              <li>
                <strong>Experience</strong> - Our team of <strong>seasoned consultants</strong> leverages decades of higher education and executive search expertise to navigate complex placements seamlessly.
              </li>
              <li>
                <strong>Talent</strong> - We provide access to a network of <strong>highly qualified, top-tier candidates</strong> you simply won't find on your own.
              </li>
              <li>
                <strong>Results</strong> - We are driven by successful, <strong>lasting placements</strong>—leaders who will make a measurable and transformative impact on your institution's future.
              </li>
            </ul>
          </div>
        </div>
        <div className="our-history-mission">
          <h2 className="mission-title">Our Mission</h2>
          <div className="mission-content">
            <p>
              To serve with integrity, effectiveness, and authenticity—fostering trust through ethical action, delivering meaningful results, and building genuine relationships that reflect our commitment to the people and institutions we support.
            </p>
          </div>
        </div>
        <div className="our-history-vision">
          <h2 className="vision-title">Our Vision</h2>
          <div className="vision-content">
            <p>
              To empower institutions that serve people by enhancing their capabilities with integrity and <strong>leveraging modern search methodologies</strong>, creating a future where progress, purpose, and ethical service work hand in hand to improve human experience.
            </p>
          </div>
        </div>
      </div>
      <div className="our-history-contact">
        <h2 className="contact-title">Ready to Find Your Next Visionary Leader?</h2>
        <p className="contact-subtitle">Partner with Myers McRae to secure the exceptional leadership your institution deserves.</p>
        <div className="contact-buttons">
          <button 
            className="contact-button contact-button-primary"
            onClick={() => {
              navigate('/contact-us');
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            Contact Us Today
          </button>
          <button 
            className="contact-button contact-button-secondary"
            onClick={() => {
              navigate('/news-and-insights/recent-placements');
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          >
            View Our Recent Placements
          </button>
        </div>
      </div>
    </div>
  );
};

export default OurHistory;

